export default __webpack_public_path__ + "static/media/group-assignee.dc7cda75.svg";